export function openAppAdvertisementOverlay(modalPath: string): void {
  void up.layer.open({
    url: modalPath,
    history: false,
    class: 'get-native-app-modal',
    size: 'auto',
    dismissible: ['key', 'button'],
    abort: 'all',
  })
}
